"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var messages = (0, _reactIntl.defineMessages)({
  campaign_stars: {
    "id": "campaign_stars",
    "defaultMessage": "{numberOfStars, number} {numberOfStars, plural, one {star} other {stars}}"
  }
});
var _default = exports["default"] = messages;
//# sourceMappingURL=messages.js.map